import { Card, Typography, Tabs } from "antd";
import { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import { changeLoader } from "../../redux/reducers/loader";
import globalRequest from "../../utils/global/globalRequest";
import * as Apis from "../../utils/helper/enum";
import CannedOrderListDetail from "./CannedOrderListDetail";

const { Title } = Typography;
const { TabPane } = Tabs;

const CannedOrderManagement = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState("ready-to-ship");
  const [statusCounts, setStatusCounts] = useState({ readyToShipCount: 0, deliveredCount: 0 });

  const getOrderStatusCounts = async () => {
    try {
      let response = await globalRequest(
        Apis.MANAGE_CANNED_ORDER.ORDER_STATUS_COUNT,
        "get",
        {},
        {},
        true
      );
      if (response?.status === 200) {
        setStatusCounts(response?.data?.data || { readyToShipCount: 0, deliveredCount: 0 });
      }
    } catch (e) {
      console.error("Failed to fetch order status counts", e);
    }
  };

  useEffect(() => {
    getOrderStatusCounts();
  }, []);

  return (
    <Card className="res-tabs">
      <div className="flex justify-between mb-4">
        <Title level={4} className="mb-0">Canned Order Management</Title>
      </div>

      <div className="custom-tabs">
        <Tabs 
          activeKey={activeTab} 
          onChange={(key) => setActiveTab(key)}
          className="OrderManagement-tab"
        >
          <TabPane 
            tab={
              <>
                Ready to Ship <span>{statusCounts.readyToShipCount}</span>
              </>
            } 
            key="ready-to-ship"
          >
            {activeTab === "ready-to-ship" && (
              <CannedOrderListDetail 
                activeTab="ready-to-ship" 
                getStatusCounts={getOrderStatusCounts} 
              />
            )}
          </TabPane>
          <TabPane 
            tab={
              <>
                Delivered <span>{statusCounts.deliveredCount}</span>
              </>
            } 
            key="delivered"
          >
            {activeTab === "delivered" && (
              <CannedOrderListDetail 
                activeTab="delivered" 
                getStatusCounts={getOrderStatusCounts} 
              />
            )}
          </TabPane>
        </Tabs>
      </div>
    </Card>
  );
};

export default CannedOrderManagement;
